import { connect } from "react-redux";

import { requestDailyStatistics, filterDataCompressorsEnergieverbrauch } from "../model/util/DailyValues";
import EnergieverbrauchChart from "./EnergieverbrauchChart";

export default connect(state => ({
	model: filterDataCompressorsEnergieverbrauch(state.charts.daily_values.energieverbrauch, state.ablauf.compressors),
	timespan: state.charts.daily_values.timespan,
	rtc: state.rtc,
	compressors: state.ablauf.compressors
}), dispatch => ({
	refresh: timespan => {
		requestDailyStatistics("energieverbrauch",
			timespan.from_ms, timespan.until_ms, dispatch);
	}
}))(EnergieverbrauchChart);
